<template>
	<div>
		<ChangeController
			:visible="dataChanged"
			@close="show = false"
			@revert="revert"
			@save="save"
		/>
		<v-card>
			<v-card-text>
				<section class="mb-10">
					<h2 class="mb-4">File Attachments</h2>
					<Collection
						cols='auto'
						:collection="data.files"
						@change="dataChanged = true"
						dialogWidth="600"
						:form="$options.FileForm"
						title="File Attachment"
						breakpoints="xs12 sm3 md3 lg3 xl2"
						isFileUpload
					>
						<FileItem slot-scope="{ item }" v-bind="item" />
					</Collection>
				</section>
				<section class="mt-10 mb-10">
					<h2 class="mb4">Distributors</h2>
					<TextEditor
						v-model="data.distributorInfo"
						@show-change="dataChanged = true"
					/>
				</section>
				<section class="mb-10">
					<h2 class="mb-4">How to become a PRIMAR Distributor</h2>
					<TextEditor 
						v-model="data.becomeDistributor" 
						@show-change="dataChanged = true" 
					/>
				</section>
				<section>
					<h2 class="mb-4">Distributor Services</h2>
					<Collection
						:collection="data.services"
						@change="dataChanged = true"
						dialogWidth="800"
						:form="$options.ServiceForm"
						title="Service"
						breakpoints="xs12 sm3 md3 lg3 xl2"
					>
						<ServiceItem slot-scope="{ item }" v-bind="item" />
					</Collection>
				</section>
				<!-- <section class="mt-10 mb-10">
					<h2 class="mb-4">Distribution Network</h2>
					<Collection
						:collection="data.distributors"
						@change="dataChanged = true"
						dialogWidth="600"
						:form="$options.CountryForm"
						title="Distributor"
						breakpoints="xs12 sm3 md3 lg3 xl2"
					>
						<CountryItem slot-scope="item" v-bind="item" />
					</Collection>
				</section> -->
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import TextEditor from '@/components/admin/TextEditor'
import DataMixin from '@/mixins/DataMixin'

import Collection from '@/components/admin/ItemCollection'
import ServiceItem from '@/components/n-collections/n-items/ServiceItem'
import CountryItem from '@/components/n-collections/n-items/CountryItem'
import FileItem from '@/components/n-collections/n-items/FileItem'

import ServiceForm from '@/components/dialogs/forms/ServiceForm'
import CountryForm from '@/components/dialogs/forms/CountryForm'
import FileForm from '@/components/dialogs/forms/FileForm'

import { Storage } from '@aws-amplify/storage'
import { Auth } from '@aws-amplify/auth'

export default {
	name: 'AdminDistributors',
	mixins: [DataMixin],
	components: {
		TextEditor,
		Collection,
		ServiceItem,
		CountryItem,
		FileItem,
	},
	FileForm,
	ServiceForm,
	CountryForm,
	methods: {
		setUploadFile(file) {
			this.uploadFile = file
		},
		insertFile(file) {
			// Create files array if not present
			if (!this.data.files) this.$set(this.data, 'files', [])
			this.data.files.push(file)
			this.dataChanged = true
		},
		async doUpload() {
			const name = this.uploadFilename
			const file = this.uploadFile //$refs.fileInput.files

			const savedFile = await FileService.uploadS3(name, file)

			// Create files array if not present
			if (!this.data.files) this.$set(this.data, 'files', [])
			this.data.files.push(savedFile)
		},
	},
}
</script>

<style lang="scss" scoped>
</style>